<template>
      <div v-if="loading">
        <loader></loader>
      </div>
      <div v-else>
        <div class="row">
          <steps :steps="steps" :request="request" :editable=false :groups="groups"></steps>
        </div>
        <div class="row">
          <div class="info col-sm-9">
            <div class="table-responsive">
              <request-user-linked :linked='otherRequests' :request='request'></request-user-linked>
              <table v-for="(fields, sectionId, i) in fieldsGroups" class="table table-bordered table-striped" style="table-layout: fixed">
                <thead>
                  <tr class="alert alert-info">
                    <th colspan="2">
                      <span v-if="sectionId">{{i + 1}}. {{getSection(sectionId).name}}</span>
                      <span v-else>Dados</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="edit-button"
                      v-for="field in fields" :key="field.objectId"
                      v-if="!field.newerVersion">
                    <td><strong>{{field.name}}</strong></td>
                    <td>
                      <span v-if="showEditField && field.type !== 'computed'"
                            @click="openEditModal(field)"
                            class="edit-icon pull-right glyphicon glyphicon-edit"
                            style="padding-left: 5px">
                      </span>
                      <dynamic-view-field :showVersions="true" :field="field" :sectionOrder="i" 
                        :sectionId="sectionId" :fields="fields">
                      </dynamic-view-field>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table v-for="info in additionalFields" class="table table-bordered table-striped" style="table-layout: fixed">
                <thead>
                  <tr class="step-title">
                    <th colspan="2">Passo: {{info.step.name}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="field in info.fields">
                    <td>{{field.name}}</td>
                    <td>
                      <dynamic-view-field :field="field" :sectionOrder="i" :sectionId="sectionId"></dynamic-view-field>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <hr>
              <p><b>Comentários mais recentes</b> <span style="font-size: 10px">(Mensagens)</span></p>
              <br>
              <div class="comments">
                <div v-for="comment in comments" v-if="comment.message" class="row comment">
                  <div class="comment-timeline" :class="comment.event"></div>
                  <div class="col-sm-1">
                    <div class="text-center">
                      <span class="glyphicon glyphicon-user profile"></span>
                    </div>
                  </div>
                  <div class="col-sm-11" >
                    <div class="panel panel-default" >
                      <div class="panel-heading" :class="comment.event">
                        <span v-if="comment.private" title="Comentário privado" class="glyphicon glyphicon-lock"></span>
                        <span class="comment-user-name">Usuário</span>
                        <span class="comment-date">{{formatDate(comment.createdAt)}}</span>

                        <span class="react-box pull-right">
                          <button class="btn btn-default btn-xs btn-like glyphicon glyphicon-thumbs-up" 
                            v-on:click="like(comment)" 
                            v-bind:class="{ liked: comment.likes.indexOf(user.id) >= 0 }"
                            :disabled="comment.dislikes.indexOf(user.id) >= 0">
                          </button> 
                          <span class="like-count">{{ comment.likes.length }}</span>
                          <button class="btn btn-default btn-xs btn-dislike glyphicon glyphicon-thumbs-down" 
                            v-on:click="dislike(comment)" 
                            v-bind:class="{ disliked: comment.dislikes.indexOf(user.id) >= 0 }"
                            :disabled="comment.likes.indexOf(user.id) >= 0">
                          </button>
                          <span class="dislike-count">{{ comment.dislikes.length }}</span>
                        </span>
                      </div>
                      <div class="panel-body comment-message" v-if="comment.message">
                        <span class="react-box pull-right">
                          <button v-if="comment.owner.objectId === user.id && comment.event === 'note'" class="btn btn-default btn-xs glyphicon glyphicon-trash" 
                            v-on:click="deleteComment(comment)" >
                          </button> 
                        </span>
                        <div class="speech-bubble-arrow" :class="comment.event"></div>
                        <div v-html="comment.message || '<i>Sem observações</i>'">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <quill-editor v-model="content"
                              :config="editorConfig" class="comment_editor">
                  </quill-editor>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" name="private-comment" v-model="privateComment"> Tornar o comentário privado.
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <button class="btn btn-primary" @click="saveComment('note')">Enviar</button>
              </div>
          </div>
          <div class="text-center col-sm-3">
            <div v-if="request.status == 'processing'">
              <div class="row" v-if="!isLastStep && canTrammit">
                <button id="btn-trammit" class="btn btn-primary control"  @click="openTrammitModal('processing')">
                  <span class="glyphicon glyphicon-arrow-right"></span>
                  <span v-if="!customizations.trammitButton">Tramitar</span>
                  <span v-else>{{customizations.trammitButton}}</span>
                </button>
              </div>
              <a v-if="!seeMore && canTrammit" @click="seeMore = true" class="btn">
                Ver mais opções
              </a>
              <transition name="fade">
                <div class="row" v-if="seeMore">
                  <button id="btn-grant" class="btn btn-success control" @click="openTrammitModal('grant')" v-if="canTrammit">
                    <span class="glyphicon glyphicon-thumbs-up"></span>
                    <span v-if="!customizations.grantButton">Finalizar com Sucesso</span>
                    <span v-else>{{customizations.grantButton}}</span>
                  </button>
                  <button v-if="(seeMore || isFirstStep) && canTrammit" id="btn-deny" class="btn btn-danger control" @click="openTrammitModal('deny')">
                    <span class="glyphicon glyphicon-thumbs-down"></span>
                    <span v-if="!customizations.denyButton">Rejeitar</span>
                    <span v-else>{{customizations.denyButton}}</span>
                  </button>
                  <button v-if="seeMore && !isFirstStep && canRevert" class="btn btn-primary control" @click="openTrammitModal('revert')">
                    <span class="glyphicon glyphicon glyphicon-erase"></span> Reverter
                  </button>
                </div>
              </transition>
              <hr v-if="currentStepActions.length"/>
              <div class="row" v-for="action in currentStepActions">
                <button class="btn btn-primary control" @click="openActionModal(action)" v-if="action.type === 'form'">{{action.name}}</button>
                <a :href="action.value" class="btn btn-primary control" target="_blank" v-else-if="action.type === 'link'">
                  <span class="glyphicon glyphicon-new-window"></span> {{action.name}}
                </a>
              </div>
              <hr/>
              <div class="row" v-if="canTrammit">
                <button id="btn-deny" class="btn btn-default control" @click="inviteUser">
                  <span class="glyphicon glyphicon-share"></span>
                  Convites
                </button>
              </div>
              <div class="row" v-if="canTrammit">
                <button id="btn-email" class="btn btn-default control" @click="sendEmail()">
                  <span class="glyphicon glyphicon-envelope"></span>
                  Contactar por email
                </button>
              </div>      
              <div class="row" v-if="canTrammit">
                <button id="btn-email" :disabled="ownerInvite !== undefined" class="btn btn-primary control" @click="inviteOwner">
                  <span class="glyphicon glyphicon-pencil"></span>
                  Solicitar Correção
                </button>
                <div style="font-size: 10px; color: gray;" v-show="ownerInvite">Requisitante já foi notificado.</div>
              </div>
            </div>             

            <div v-else class="result text-center">
              <span v-if="request.status == 'grant'" class="glyphicon glyphicon-ok ok"></span>
              <span v-if="request.status == 'deny'" class="glyphicon glyphicon-remove notOk"></span>
              <span v-if="request.status == 'processing'" class="glyphicon glyphicon-hourglass wait"></span>
            </div>
            <div style="margin-top: 20px">
              <button class="btn btn-primary control" v-if="canReopen" @click="openTrammitModal('reopen')">
                <span class="glyphicon glyphicon-open"></span> Reabrir
              </button>
            </div>
            <hr>
            <comment-timeline-overview :comments="comments"></comment-timeline-overview>
          </div>
          <div class="info col-sm-9" v-if="actionFormValues.length">
            <table v-for="(fields, actionId, i) in actionValuesGroups" :key="action" 
              class="table table-bordered table-striped request-table action-fields-table" style="table-layout: fixed">
              <thead>
                <tr class="title">
                  <th colspan="2">{{getActionName(actionId)}}</th>
                </tr>
              </thead>
              <tbody v-for="field in fields" :key="field.objectId">
                <tr :class="{ 'user-evaluation': field.type == 'user' }">
                  <td>{{field.name}}</td>
                  <td>
                    <dynamic-view-field :field="field" :sectionOrder="i" :sectionId="sectionId"></dynamic-view-field>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>          
        </div>
        <modal v-if="showModal" @close="closeModal()">
            <h2 slot="header">
              <span v-if="commentEvent == 'processing'">
                <span v-if="!customizations.trammitButton">Tramitar Requisição</span>
                <span v-else>{{customizations.trammitButton}}</span>
              </span>
              <span v-if="commentEvent == 'grant'">
                <span v-if="!customizations.grantButton">Aprovar Requisição</span>
                <span v-else>{{customizations.grantButton}}</span>
              </span>
              <span v-if="commentEvent == 'deny'">
                <span v-if="!customizations.denyButton">Rejeitar Requisição</span>
                <span v-else>{{customizations.denyButton}}</span>
              </span>
            </h2>
            <div slot="body">
              <div class="alert alert-info">
                <strong>Atenção: </strong>
                Tem certeza que deseja 
                <span v-if="commentEvent == 'processing'">tramitar a requisição para o próximo passo (<strong>{{getNextStep()}}</strong>)?</span>
                <span v-if="commentEvent == 'grant'">finalizar o processamento com <strong class="grant">sucesso</strong>?</span>
                <span v-if="commentEvent == 'deny'"><strong class="deny">rejeitar</strong> a requisição e finalizar o processo?</span>
                <span v-if="commentEvent == 'reopen'">reabrir a requisição?</span>
                <span v-if="commentEvent == 'revert'">reverter a requisição para o passo anterior?</span>
              </div>
              <fieldset v-if="privateStepFields.length > 0">
                <legend>Informações Privadas</legend>
                <div class="form-group" v-for="formField in privateStepFields">
                  <label :for="formField.objectId" class="field-label">
                    {{ formField.name }}<span v-if="formField.required" class="required"> *</span>
                  </label>
                  <p class="text-muted field-desc">{{formField.description}}</p>
                  <input type="text" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-if="formField.type === 'text'" />
                  <textarea rows="4" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-if="formField.type === 'textarea'"></textarea>
                  <input type="url" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'link'" />
                  <input type="number" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'number'" />
                  <datepicker type="date" :clear-button="true" v-model="formField.value" required format="dd/MM/yyyy" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'date'" language="pt-br" input-class="form-control field-date"></datepicker>
                  <select class="form-control" v-model="formField.value" :placeholder="'Entre com o(a) ' + formField.name" v-else-if="formField.type === 'select'">
                    <option v-for="option in formField.options" v-bind:value="option">{{ option.name }}</option>
                  </select>
                  <input type="file" @change="onChange(formField, $event)" required class="form-control" :id="formField.objectId" v-else-if="formField.type === 'file'" />
                </div>
              </fieldset>
              <fieldset v-if="publicStepFields.length > 0">
                <legend>Informações Públicas</legend>
                <div class="form-group" v-for="formField in publicStepFields">
                  <label :for="formField.objectId" class="field-label">
                    {{ formField.name }}<span v-if="formField.required" class="required"> *</span>
                  </label>
                  <p class="text-muted field-desc">{{formField.description}}</p>
                  <input type="text" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-if="formField.type === 'text'" />
                  <textarea rows="4" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-if="formField.type === 'textarea'"></textarea>
                  <input type="url" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'link'" />
                  <input type="number" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'number'" />
                  <datepicker type="date" :clear-button="true" v-model="formField.value" required format="dd/MM/yyyy" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'date'" language="pt-br" input-class="form-control field-date"></datepicker>
                  <select class="form-control" v-model="formField.value" :placeholder="'Entre com o(a) ' + formField.name" v-else-if="formField.type === 'select'">
                    <option v-for="option in formField.options" v-bind:value="option">{{ option.name }}</option>
                  </select>
                  <input type="file" @change="onChange(formField, $event)" required class="form-control" :id="formField.objectId" v-else-if="formField.type === 'file'" />
                </div>
              </fieldset>
              <label>Comentário</label>
              <quill-editor v-model="contentModal" :config="editorConfig" class="comment_editor"></quill-editor>
            </div>
            <button slot="footer" id="btn-confirm" class="btn btn-primary" @click="prepareFieldsToSave()">Confirmar</button>
        </modal>
        <modal v-if="showActionModal" @close="closeModal()">
            <h2 slot="header">{{currentAction.name}}</h2>
            <div slot="body">
              <div v-if="loadingAction">
                <loader></loader>
              </div>
              <div v-else class="form">
                <div class="alert alert-warning" v-if="!actionFields.length">
                  Nenhum campo para avaliação foi cadastrado.
                </div>
                <div class="form-group" v-else v-for="formField in actionFields">
                  <label :for="formField.objectId" class="field-label">
                    {{ formField.name }}<span v-if="formField.required" class="required"> *</span>
                  </label>
                  <p class="text-muted field-desc">{{formField.description}}</p>
                  <input type="text" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-if="formField.type === 'text'" />
                  <textarea rows="4" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-if="formField.type === 'textarea'"></textarea>
                  <input type="url" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'link'" />
                  <input type="number" v-model="formField.value" required class="form-control" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'number'" />
                  <datepicker type="date" :clear-button="true" v-model="formField.value" required format="dd/MM/yyyy" :placeholder="'Entre com o(a) ' + formField.name" :id="formField.objectId" v-else-if="formField.type === 'date'" language="pt-br" input-class="form-control field-date"></datepicker>
                  <select class="form-control" v-model="formField.value" :placeholder="'Entre com o(a) ' + formField.name" v-else-if="formField.type === 'select'">
                    <option v-for="option in formField.options" v-bind:value="option">{{ option.name }}</option>
                  </select>
                  <input type="file" @change="onChange(formField, $event)" required class="form-control" :id="formField.objectId" v-else-if="formField.type === 'file'" />
                  <input type="text" :value="user.get('name')" class="form-control" :id="formField.objectId" v-if="formField.type === 'user'" readonly />
                </div>
              </div>
            </div>
            <button slot="footer" id="btn-confirm" class="btn btn-primary" :disabled="!actionFields.length" @click="processStepActions()">Confirmar</button>
        </modal>

        <modal v-if="showEditModal" @close="closeModal()">
            <h2 slot="header">EDIÇÃO</h2>
            <div slot="body">
              <p>Valor Atual:</p>
              <dynamic-view-field :field="currentEditField">
              </dynamic-view-field>
              <hr>
              <p>Novo Valor:</p>
              <dynamic-form-field :onChange="onChange" :formField="newEditField">
              </dynamic-form-field>
            </div>
            <button slot="footer" id="btn-confirm" class="btn btn-primary"
                @click="saveNewFieldVersion(currentEditField.objectId, newEditField)">Salvar</button>
        </modal>
            
      </div>
</template>

<script>

import Loader from './util/Loader'
import Steps from './util/Steps'
import { quillEditor } from 'vue-quill-editor'
import { Parse, miniToastr, createParseFile } from '../Global'
import Datepicker from 'vuejs-datepicker'
import Modal from './util/Modal'
import moment from 'moment'
import RequestStatus from './util/RequestStatus'
import DynamicViewField from './util/DynamicViewField'
import DynamicFormField from './util/DynamicFormField'
import RequestUserLinked from './RequestUserLinked'
import RequestMetadata from './RequestMetadata'
import CommentTimelineOverview from './util/CommentTimelineOverview'
import { handleParseError } from './util/ErrorHandling'
moment.locale('pt-br')
var Step = Parse.Object.extend('Step')
var StepAction = Parse.Object.extend('StepAction')

export default {
  components: {
    Loader,
    Steps,
    quillEditor,
    Datepicker,
    Modal,
    RequestStatus,
    RequestMetadata,
    RequestUserLinked,
    DynamicViewField,
    DynamicFormField,
    CommentTimelineOverview
  },
  data () {
    return {
      content: '',
      contentModal: '',
      user: Parse.User.current(),
      cloudResponse: null,
      privateComment: true,
      loading: false,
      advanced: false,
      isLastStep: false,
      isFirstStep: false,
      canTrammit: false,
      canReopen: false,
      canRevert: false,
      showEditField: false,
      isInvited: false,
      showActionModal: false,
      loadingAction: false,
      seeMore: false,
      showRequestData: false,
      showEditModal: false,
      customizations: {},
      editorConfig: {
        placeholder: 'Digite um comentário aqui...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'],
          [{ 'header': 1 }, { 'header': 2 }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ 'color': [] }, { 'background': [] }],
          ['link', 'image']
          ]
        }
      },
      commentEvent: 'note',
      showModal: false,
      steps: [],
      stepCurrentIndex: 0,
      stepFields: [],
      actionFields: [],
      actionFormValues: [],
      currentAction: null,
      currentStepActions: [],
      groups: [{objectId: '1', name: 'Grupo Test'}],
      newEditField: {},
      request: {
        owner: {
          name: 'Carregando... ',
          group: {
            name: ''
          }
        },
        reqType: {
          name: ''
        }
      },
      otherRequests: [],
      comments: [],
      fields: [],
      additionalFields: [],
      formSections: []
    }
  },
  mounted () {
    let id = this.$route.params.id
    this.getById(id)
  },
  computed: {
    privateStepFields () {
      return this.stepFields.filter(f => f.private)
    },
    publicStepFields () {
      return this.stepFields.filter(f => !f.private)
    },
    fieldsGroups () {
      let groups = {}
      this.fields.filter(i => i.section).forEach(item => {
        let key = item.sectionOrder + '-' + item.section.objectId
        let list = groups[key]
        if (list) {
          list.push(item)
        } else {
          groups[key] = [item]
        }
      })
      this.fields.filter(i => !i.section).forEach(item => {
        if (!groups['*']) {
          groups['*'] = []
        }
        groups['*'].push(item)
      })
      return groups
    },
    actionValuesGroups () {
      let groups = {}
      this.actionFormValues.forEach(item => {
        let list = groups[item.stepAction.objectId]
        if (list) {
          list.push(item)
        } else {
          groups[item.stepAction.objectId] = [item]
        }
      })
      return groups
    }
  },
  methods: {
    onChange (formField, event) {
      if (formField.type === 'file') {
        createParseFile(formField, event)
      }
    },
    openEditModal (field) {
      let self = this
      self.findFormField(field).then(formField => {
        self.currentEditField = field
        self.newEditField = JSON.parse(JSON.stringify(field))
        self.newEditField.options = formField.get('options')
        if (self.newEditField.type === 'checkbox') {
          self.newEditField.value = []
        }
        delete self.newEditField['objectId']
        self.showEditModal = true
      })
    },
    findFormField (fieldValue) {
      let reqType = new Parse.Object('RequestType')
      reqType.set('objectId', fieldValue.request.reqType.objectId)
      let formFieldQuery = new Parse.Query('FormField')
      formFieldQuery.equalTo('reqType', reqType)
      formFieldQuery.equalTo('name', fieldValue.name)
      return formFieldQuery.first()
    },
    saveNewFieldVersion (oldId, newFieldVersion) {
      let self = this
      let promiseField = Parse.Promise.as('')
      if (newFieldVersion.type === 'date') {
        newFieldVersion.value = newFieldVersion.dateValue ? moment(newFieldVersion.dateValue, 'DD/MM/YYYY').toDate() : undefined
      } else if (newFieldVersion.type === 'money') {
        newFieldVersion.value = parseFloat(newFieldVersion.value)
      } else if (newFieldVersion.type === 'file' || newFieldVersion.type === 'document') {
        promiseField = newFieldVersion.value.save()
      }
      promiseField.then(() => {
        return Parse.Cloud.run('newFieldValueVersion', {olderFieldValueId: oldId, newVersion: newFieldVersion})
      }).then(() => {
        miniToastr.success('Valor atualizado')
        self.closeModal()
        self.getById(self.request.objectId)
      }).fail(error => {
        error.message = 'Erro na atualização do valor: ' + error.message
        handleParseError(self, error)
      })
    },
    formatDate (date) {
      return moment(new Date(date)).fromNow()
    },
    getNextStep () {
      return this.steps[this.stepCurrentIndex + 1].name
    },
    getById (id) {
      let self = this
      self.loading = true
      let params = {
        id: id
      }
      Parse.Cloud.run('request', params).then((res) => {
        self.cloudResponse = res
        var jsonResponse = JSON.parse(JSON.stringify(res))
        self.request = Object.assign({}, jsonResponse.request)
        self.otherRequests = Object.assign([], jsonResponse.otherRequests)
        self.fields = Object.assign([], jsonResponse.fields)
        self.comments = Object.assign([], jsonResponse.comments)
        self.steps = Object.assign([], jsonResponse.steps)
        self.canTrammit = jsonResponse.canTrammit
        self.isInvited = jsonResponse.isInvited
        self.canReopen = jsonResponse.canReopen
        self.canRevert = jsonResponse.canRevert
        self.showEditField = jsonResponse.showEditField
        self.additionalFields = jsonResponse.additionalFields
        self.actionFormValues = jsonResponse.actionFormValues
        self.customizations = jsonResponse.customizations
        self.currentStepActions = jsonResponse.currentStepActions
        self.formSections = jsonResponse.formSections
        self.ownerInvite = jsonResponse.ownerInvite
        let isCompleted = false
        let stepsReversed = Object.assign([], self.steps).reverse()
        var i = stepsReversed.length - 1
        var stepIndex = i
        stepsReversed.forEach(s => {
          if (isCompleted) {
            s.completed = true
          }
          if (self.request.currentStep !== undefined && self.request.currentStep.objectId === s.objectId) {
            isCompleted = true
            s.active = true
            stepIndex = i
            self.stepCurrentIndex = stepIndex
          } else {
            i--
          }
        })
        self.isLastStep = stepIndex === stepsReversed.length - 1
        self.isFirstStep = stepIndex === 0
        self.loading = false
      }).fail(error => {
        handleParseError(self, error)
      })
    },
    formFieldIsValid (field) {
      let valid = true
      if (field.required && (field.value === undefined || field.value === '') && field.type !== 'user') {
        valid = false
      }
      return valid
    },
    prepareFieldsToSave () {
      let self = this
      if (self.contentModal && self.contentModal.length) {
        self.content = self.contentModal
        self.contentModal = ''
      }
      if (self.commentEvent === 'reopen') {
        self.reopen()
        return
      }
      if (self.commentEvent === 'revert') {
        self.revert()
        return
      }
      if (!self.stepFields.every(f => self.formFieldIsValid(f))) {
        miniToastr.warn('Todos os campos obrigatórios devem ser preenchidos corretamente.')
        return
      }
      let promises = self.stepFields.filter(f => f.type === 'file' && f.value).map(f => {
        return f.value.save()
      })
      if (promises.length > 0) {
        Parse.Promise.when(promises).then(function (results) {
          self.updateStatus()
        }, function (error) {
          handleParseError(self, error)
        })
      } else {
        self.updateStatus()
      }
    },
    reopen () {
      let self = this
      let params = {
        id: self.request.objectId,
        event: self.commentEvent,
        comment: self.content
      }
      Parse.Cloud.run('reopenRequest', params).then(() => {
        miniToastr.success('Requisição reaberta.')
        self.content = ''
        self.showModal = false
        self.getById(self.request.objectId)
      }).fail(error => {
        error.message = 'Erro na atualização da requisição: ' + error.message
        handleParseError(self, error)
      })
    },
    revert () {
      let self = this
      let params = {
        id: self.request.objectId,
        event: self.commentEvent,
        comment: self.content
      }
      Parse.Cloud.run('revertRequestStep', params).then(() => {
        miniToastr.success('Requisição revertida ao passo anterior.')
        self.content = ''
        self.showModal = false
        self.getById(self.request.objectId)
      }).fail(error => {
        error.message = 'Erro na atualização da requisição: ' + error.message
        handleParseError(self, error)
      })
    },
    updateStatus () {
      let self = this
      let params = {
        request: self.request,
        event: self.commentEvent,
        comment: self.content,
        formFields: self.stepFields
      }
      Parse.Cloud.run('updateRequestStatus', params).then(() => {
        miniToastr.success('Requisição atualizada.')
        self.content = ''
        self.showModal = false
        self.getById(self.request.objectId)
      }).fail(error => {
        error.message = 'Erro na atualização da requisição: ' + error.message
        handleParseError(self, error)
      })
    },
    saveComment (event) {
      let self = this
      self.commentEvent = event
      let activeStep = self.getActiveStep()
      let params = {
        requestId: self.request.objectId,
        stepId: activeStep ? activeStep.objectId : null,
        comment: self.content,
        event: self.commentEvent,
        privateComment: self.privateComment
      }
      self.loading = true
      Parse.Cloud.run('saveComment', params).then(results => {
        self.loading = false
        self.privateComment = true
        self.content = ''
        self.commentEvent = 'note'
        miniToastr.success('Comentário enviado')
        self.getById(self.request.objectId)
      }).fail(error => {
        self.commentEvent = 'note'
        self.loading = false
        handleParseError(self, error)
      })
    },
    deleteComment (json) {
      let self = this
      let params = {
        commentId: json.objectId
      }
      self.loading = true
      Parse.Cloud.run('deleteComment', params).then(results => {
        self.loading = false
        let id = self.$route.params.id
        self.getById(id)
        miniToastr.success('Comentário excluído')
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    openTrammitModal (eventType) {
      let self = this
      if (eventType === 'deny' || eventType === 'reopen') {
        self.stepFields = []
        self.commentEvent = eventType
        self.showModal = true
      } else {
        let step = new Step()
        step.id = self.request.currentStep.objectId
        let queryFields = new Parse.Query('StepField')
        queryFields.equalTo('step', step)
        queryFields.doesNotExist('stepAction')
        queryFields.find().then(results => {
          self.stepFields = results.map(f => f.toJSON())
          self.commentEvent = eventType
          self.showModal = true
        }).fail(error => {
          handleParseError(self, error)
        })
      }
    },
    openActionModal (action) {
      let self = this
      self.currentAction = action
      self.loadingAction = true
      self.showActionModal = true
      let step = new Step()
      step.id = self.request.currentStep.objectId
      let stepAction = new StepAction()
      stepAction.id = action.objectId
      let queryFields = new Parse.Query('StepField')
      queryFields.equalTo('step', step)
      queryFields.equalTo('stepAction', stepAction)
      queryFields.ascending('order')
      queryFields.find().then(results => {
        self.actionFields = results.map(f => f.toJSON())
        self.loadingAction = false
      }).fail(error => {
        handleParseError(self, error)
      })
    },
    processStepActions () {
      let self = this
      if (!self.actionFields.every(f => self.formFieldIsValid(f))) {
        miniToastr.warn('Todos os campos obrigatórios devem ser preenchidos corretamente.')
        return
      }
      if (confirm('Confirma o preenchimento dos campos? Esta ação não poderá ser desfeita.')) {
        let promises = self.actionFields.filter(f => f.type === 'file' && f.value).map(f => {
          return f.value.save()
        })
        if (promises.length > 0) {
          Parse.Promise.when(promises).then(function (results) {
            self.saveActionFields()
          }, function (error) {
            handleParseError(self, error)
          })
        } else {
          self.saveActionFields()
        }
      }
    },
    saveActionFields () {
      let self = this
      let params = {
        fields: self.actionFields,
        requestId: self.request.objectId,
        stepActionId: self.currentAction.objectId
      }
      Parse.Cloud.run('saveActionFields', params).then(() => {
        miniToastr.success('Avaliação aplicada.')
        self.showActionModal = false
        self.getById(self.request.objectId)
      }).fail(error => {
        error.message = 'Erro na atualização da requisição: ' + error.message
        handleParseError(self, error)
      })
    },
    sendEmail () {
      let self = this
      window.open('mailto:' + self.request.owner.email)
    },
    getActiveStep () {
      return this.steps.find(s => { return s.active })
    },
    like (json) {
      let self = this
      let params = {
        commentId: json.objectId
      }
      self.loading = true
      Parse.Cloud.run('likeComment', params).then(() => {
        self.loading = false
        let id = self.$route.params.id
        self.getById(id)
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    dislike (json) {
      let self = this
      let params = {
        commentId: json.objectId
      }
      self.loading = true
      Parse.Cloud.run('dislikeComment', params).then(() => {
        self.loading = false
        let id = self.$route.params.id
        self.getById(id)
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    inviteUser () {
      this.$router.push('/invite/' + this.request.objectId + '/' + this.getActiveStep().objectId)
    },
    inviteOwner () {
      this.$router.push('/invite/' + this.request.objectId + '/' + this.getActiveStep().objectId + '/select?ownerEditInvite=true')
    },
    closeModal () {
      this.showModal = false
      this.showActionModal = false
      this.showEditModal = false
      this.stepFields = []
    },
    getActionName (actionId) {
      return this.actionFormValues.find(item => item.stepAction.objectId === actionId).stepAction.name
    },
    getSection (objectId) {
      objectId = objectId.substring(objectId.indexOf('-') + 1, objectId.length)
      return this.formSections.find(s => s.objectId === objectId) || {}
    }
  }
}
</script>

<style scoped lang="scss">

  $active: lighten(#4183c4, 10%);
  $processing: lighten($active, 15%);
  $deny: lighten(red, 36%);
  $grant: lighten(green, 58%);

  .info {
    border: 0.5px solid #ddd;
    padding: 1em;
    margin-bottom: 15px;
  }
  .extra-info {
    color: #aaa;
    margin-top: 5px;
    font-size: 12px;
  }
  .row {
    margin-top: 1em;
  }
  .control {
    width: 70%;
    margin-bottom: 5px;
  }
  .profile {
    font-size: 40px;
  }
  .comments {
    position: relative;
  }

  .result {
    font-size: 100px;
    border: 1px solid #ddd;
    border-radius: 50%;
    width: 150px;
    height: 150px;
    padding: 15px;  
    margin: 0 auto;
    .ok {
      color: lighten(green, 30%)
    }
    .notOk {
      color: lighten(red, 30%)
    }
  }
  .comment {
    padding-top: 2px;
    padding-right: 2px;
    border-left: 1.5px solid #ddd;
    margin: 0 !important;
  }

  .comment-user-name {
    font-size: 14px;
    font-weight: bold;
  }

  .comment-date {
    margin-left: 10px;
    font-size: 12px;
    color: darken(gray, 10%);
  }

  .comment-message {
    padding-bottom: 10px;
  }
  .comment-timeline{
    content: '';
    position: absolute;
    margin-top: 20px;
    border: 1px solid white;
    background: darken(#ddd, 10%);
    width: 10px;
    height: 10px;
    left: -4px;
    border-radius: 50%;
  }
  /* https://www.natashatherobot.com/speech-bubble-css/ */
  .speech-bubble {
      background-color: #f8f8f8;
      border: 1px solid #ddd;
      border-radius: 5px;
      padding: 20px;
  }
  .processing {
    background: $processing !important;
    border-color: $processing !important;
  }
  .deny {
    background: $deny !important;
    border-color: $deny !important;
  }
  .grant {
    background: $grant !important;
    border-color: $grant !important;
  }
  .edit {
    background: rgb(255, 145, 0);
  }
  .wait {
    color: #7d6a6a
  }
  .speech-bubble-arrow {
    position: absolute;
    content: '';
    top: 20px;
    left: 0.1em;
    border: medium none;
    background: #f8f8f8;
    width: 1em;
    height: 1em;
    border-style: solid;
    border-color: #ddd;
    border-width: 1px 0px 0px 1px;
    transform: translateY(-50%) translateX(50%) rotate(-45deg);
  }
  .react-box {
    margin-left: 10px;
  }
  .react-box a {
    padding-left: 5px;
  }
  .react-box a:before {
    padding-right: 5px;
  }
  .like-controls {
    margin-top: -4px;
  }
  .btn-like {
    @extend .like-controls;
  }
  .btn-dislike {
    margin-left: 15px;
    @extend .like-controls;
  }
  .btn-like:hover {
    color: green;
  }
  .btn-dislike:hover {
    color: red;
  }
  .liked {
    color: green;
    background: lighten(green, 70%);
  }
  .disliked {
    color: red;
    background: lighten(red, 50%);
  }
  .request-table thead {
    // background: $active;
    // color: white;
    font-size: 14px;
  }

  .action-fields-table thead .title {
    background: #58a559;
    color: white;
  }

  .user-evaluation {
    background-color: #e2fdd7 !important
  }

  .request-table tbody td {
    padding-left: 15px;
  }
  .request-table tbody td:first-child {
    // font-weight: bolder;
    font-style: italic;
  }
  .request-table tbody tr.step-title {
    background: #8fb3d6;
    color: white;
  }
  .request-table tbody tr.step-title td {
    padding-left: 8px;
  }
  .field-label {
    margin-bottom: 0px;
  }
  .field-desc {
    margin-bottom: 3px;
    font-size: 0.85em;
  }
  .clickable {
    color: $active;
    cursor: pointer;
  }
  .edit-icon {
    cursor: pointer;
    color: #689cd0;
  }
  .show-more {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// RequestDetail.vue?7ae475c4